import type { Theme } from '@escala/domain/types';

import { preferenceStorage } from '@/privacy/consent';

/**
 * O tema da interface no navegador. A escolha de verdade é da conta (`users.theme`, por
 * `GET /auth/me`), que vale em qualquer computador; esta cópia local existe para o
 * recarregar e o login abrirem já no tema certo, sem piscar o claro antes. O script do
 * `index.html` lê a mesma chave antes de o React carregar — `theme.test.ts` trava.
 */
export const THEME_KEY = 'escala:theme';

export function isTheme(value: unknown): value is Theme {
  return value === 'light' || value === 'dark';
}

/** O tema guardado neste navegador; o claro, como no protótipo, se não houver. */
export function storedTheme(): Theme {
  try {
    const value = window.localStorage.getItem(THEME_KEY);

    return isTheme(value) ? value : 'light';
  } catch {
    return 'light';
  }
}

/**
 * Cookie funcional: sem o consentimento (Política de Cookies), o tema vale até
 * recarregar — com a conta, ele também fica salvo nela.
 */
export function storeTheme(theme: Theme): void {
  preferenceStorage.set(THEME_KEY, theme);
}

/** Liga o tema no documento: `data-theme` decide o `color-scheme` dos tokens. */
export function applyTheme(theme: Theme): void {
  document.documentElement.dataset.theme = theme;
}

export const THEME_COPY: Record<Theme, { action: string; item: string }> = {
  light: { action: 'Ativar tema escuro', item: 'Tema escuro' },
  dark: { action: 'Ativar tema claro', item: 'Tema claro' },
};
